import { Autocomplete, Box, TextField, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { useSurveyStyles } from "../SurveyComponents/NewSurveyFront/Context/SurveyCustomHooks/useSurveyStyles";
import MetaDecorator from "../UtilsComponents/MetaDecorator";
import { NotFound } from "../ErrorComponents/NotFound";
import axios from '../../../src/api/axios';
import { SurveySkeleton } from "../SurveyComponents/NewSurveyFront/SurveyComponents/SurveySkeleton";
import { QuestionError } from "../SurveyComponents/NewSurveyFront/SurveyComponents/SurveyQuestions/QuestionError";
import { useQuery } from "@tanstack/react-query";

// Get all surveys by store ID
export const StoreSurvey = () => {
    const navigate = useNavigate();
    // const intl = useIntl();
    let { storeId, customer } = useParams();
    customer = customer.toLowerCase();
    const isSmallScreen = useMediaQuery('(max-width:480px)');
    const { surveyStyles, isLoadingStyles, isErrorStyles } = useSurveyStyles();
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');
    const backgroundColor = 'whitesmoke'

    const { data, isLoading: isLoadingSurveys, isError: isErrorSurveys } = useQuery({
        queryKey: ["Surveys", storeId, customer],
        queryFn: async () => {
            const response = await axios.get(`store/store/${storeId}?customer=${customer}`);
            const result = response.data
            return result;
        },
        refetchOnWindowFocus: false,
        retry: 0,
    });

    const handleSurveyChange = (e, value) => {
        setSelectedSurvey(value);
        if (errorMsg !== '') {
            setErrorMsg('');
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!selectedSurvey) {
            setErrorMsg("Por favor seleccione una opción.");
            return
        }
        setErrorMsg('');
        if (customer === 'hermeco') {
            navigate(`/user/${customer}/${selectedSurvey.id}`);
            return;
        }
        navigate(`/newsurvey/${customer}/${selectedSurvey?.id}`);
    }

    return (
        isLoadingStyles || isLoadingSurveys ? <SurveySkeleton /> :
            isErrorSurveys || isErrorStyles ? <NotFound /> :
                <Box
                    sx={{
                        backgroundColor,
                        height: "100vh",
                        overflow: "hidden", // Scroll personalizado
                    }}
                >
                    <MetaDecorator
                        title={`Store | ${customer}`}
                        description={"Para nosotros es muy importante conocer tu opinión sobre nuestros productos y servicios. Por favor, ayúdanos a mejorar respondiendo esta encuesta."}
                        imageUrl={"/images/7Bytes.svg"}
                        imageAlt={"7Bytes"}
                        path={window.location.pathname}
                    />
                    <header>
                        <div
                            className="center"
                            align="center"
                            style={{
                                position: 'relative', // Necesario para posicionar el icono dentro del contenedor
                                width: '100vw', // Ocupa todo el ancho de la ventana
                                paddingBottom: '40px',
                            }}
                        >
                            <a
                                target="_blank"
                                className="mylogo"
                                rel="noreferrer"
                                href={surveyStyles?.url}
                            >
                                <img
                                    className="mylogo"
                                    alt="Logo"
                                    src={surveyStyles?.logo}
                                    border="0"
                                />
                            </a>
                        </div>
                        <div className='text-center'>
                            {surveyStyles?.subtitle && (
                                <h6 className="mt-1 LightMadeTommy" style={{ color: surveyStyles?.subtitleColor ?? "black" }}>
                                    {surveyStyles.subtitle}
                                </h6>
                            )}
                        </div>
                    </header>
                    <div className={`container text-center`} style={{ marginTop: "6vh", }}>
                        <h3 className='MediumMadeTommy mb-3' >
                            {data?.store_question || "Selecciona una encuesta"}
                        </h3>
                        <Autocomplete
                            className='center RegularMadeTommy '
                            disablePortal
                            id={`selectradiostore`}
                            options={data?.surveys || []}
                            sx={{ width: isSmallScreen ? '100%' : '70%', backgroundColor: 'white', marginTop: "6vh", }}
                            getOptionLabel={(option) => option.survey_name}
                            onChange={handleSurveyChange}
                            renderOption={(props, option, { selected }) => {
                                return (
                                    <li
                                        {...props}
                                        className="RegularMadeTommy"
                                        key={option.id}
                                        style={{
                                            textAlign: "left",
                                            padding: isSmallScreen ? "8px 30px" : "5px 30px",//Separacion de las opciones
                                            position: "relative",
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            style={{
                                                margin: "0px ",
                                                position: "absolute",
                                                left: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                            }}
                                            checked={selected}
                                            readOnly
                                        />
                                        {option.survey_name}
                                    </li>
                                )
                            }}
                            renderInput={(params) =>
                                <TextField
                                    key={`textfieldstore`}
                                    {...params}
                                    // onFocus={() => setInputClick(true)}
                                    // onBlur={() => setInputClick(false)}
                                    sx={{
                                        backgroundColor: 'white',
                                        borderRadius: '10px',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                border: 'none', // Elimina el borde del campo
                                            }
                                        },
                                    }}
                                    label={"Seleccione una opción"}
                                    className="MediumMadeTommy"
                                />
                            }
                        />
                        <QuestionError
                            errorMsg={errorMsg}
                            showError={errorMsg !== ''}
                        />
                    </div>
                    <div className={`divmysurveybtn `}>
                        <button
                            type="submit"
                            style={{
                                backgroundColor: surveyStyles.btnSubmit.bg,
                                color: surveyStyles.btnSubmit.color
                            }}
                            className="btn btn-lg shadow mysurveybtn"
                            onClick={handleSubmit}
                        >
                            <FormattedMessage
                                id="next"
                            />
                        </button>
                    </div>
                </Box>
    )
}
